import { LoanSetupScreen } from "@/screens/loans/components/setup/LoanSetupScreen"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H2, H4, H5, Body, Subtitle } from "@/components/standard/BFText"
import { View, Linking, TouchableOpacity } from "react-native"
import SuccessNextStepIcon from "@/assets/clipart/success-sext-step.svg"
import { BFColors } from "@/constants/Colors"
import { externalDashboardUrl, externalLoanDashboardUrl } from "@/screens/loans/utils/LoanUtils"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { Card, CardContent } from "@/components/reusables/ui/card"
import ArrowUpRight from "phosphor-react-native/src/icons/ArrowUpRight"
import { loanDashboardEntryClicked } from "@/analytics/events/loans"

export const LoanSubmitSuccessScreen = () => {
  const { loanApplication } = useLoanContext()

  const handleOpenDashboard = () => {
    loanDashboardEntryClicked({
      currentScreen: "Loan App Submitted Successfully",
      loanId: loanApplication?.id,
      externalLoanId: loanApplication?.externalLoanId,
    })
    const url = loanApplication?.externalLoanId
      ? externalLoanDashboardUrl(loanApplication.externalLoanId)
      : externalDashboardUrl()
    void Linking.openURL(url)
  }

  return (
    <LoanSetupScreen
      title={""}
      address={loanApplication?.property?.street}
      hideSetupHeader={true}
      hideNextButton={true}
    >
      <Vertical className="gap-6 p-6">
        {/* Success Cards */}
        <Vertical className="gap-0">
          {/* Request Received Card */}
          <Card className="mb-6 shadow-lg">
            <CardContent className="py-6 px-0">
              <Vertical className="gap-4 items-center">
                {/* Success Next Step Icon */}
                <View className="items-center">
                  <SuccessNextStepIcon width={109} height={55} />
                </View>

                {/* Text Content */}
                <Vertical className="gap-3 items-center">
                  <H2 className="text-center text-midnight-blue">
                    Request received!{"\n"}Let&apos;s keep it moving
                  </H2>
                  <Subtitle className="text-center text-midnight-blue">
                    We&apos;ll start preparing your quote.{"\n"}
                    In the meantime, complete your next{"\n"}
                    task to help us finalize your terms.
                  </Subtitle>
                </Vertical>

                {/* View Upcoming Tasks Button */}
                <View className="w-full px-8 pt-4">
                  <TouchableOpacity
                    onPress={handleOpenDashboard}
                    className="bg-calm-blue rounded-full py-4 items-center"
                    testID="view-upcoming-tasks"
                  >
                    <Horizontal className="items-center gap-2">
                      <H5 className="text-white font-bold">
                        View upcoming tasks
                      </H5>
                      <ArrowUpRight size={20} color={"white"} weight="bold" />
                    </Horizontal>
                  </TouchableOpacity>
                </View>
              </Vertical>
            </CardContent>
          </Card>

          {/* Visit Loan Dashboard Card */}
          <TouchableOpacity
            onPress={handleOpenDashboard}
            testID="visit-loan-dashboard"
          >
            <Card className="mb-4 shadow-lg">
              <CardContent className="p-6">
                <View className="flex-row justify-between items-center">
                  <Vertical className="flex-1">
                    <H4 className="text-midnight-blue">
                      Visit your Loan Dashboard
                    </H4>
                    <Body className="text-midnight-blue mt-1">
                      Track progress & handle requests
                    </Body>
                  </Vertical>
                  <View className="ml-4">
                    <ArrowUpRight
                      size={20}
                      color={BFColors.midnightBlue}
                      weight="bold"
                    />
                  </View>
                </View>
              </CardContent>
            </Card>
          </TouchableOpacity>
        </Vertical>
      </Vertical>
    </LoanSetupScreen>
  )
}
